import React from 'react';
import PropTypes from 'prop-types';
import OtherOptionsItem from './OtherOptionsItem';

const OtherOptionsList = (props) => {
  const {
    otherOptions,
    updateOtherOption,
     otherOptionSaveBody,
    showNotification,
    fetchActivities,
    calendarStartDateStr,
    calendarEndDateStr,
    onOptionToggled
   } = props;
  const otherOptionsItems = [];

  otherOptions.entries.forEach((option) => {
    otherOptionsItems.push(
      <OtherOptionsItem
        readOnly={props.readOnly || option.readOnly}
        key={option.otherOptionCode}
        title={option.name}
        subtitle={option.description}
        value={option.value}
        updateOtherOption={updateOtherOption}
        otherOptionCode={option.otherOptionCode}
        otherOptionSaveBody={otherOptionSaveBody}
        showNotification={showNotification}
        fetchActivities={fetchActivities}
        calendarStartDateStr={calendarStartDateStr}
        calendarEndDateStr={calendarEndDateStr}
        onOptionToggled={onOptionToggled}
      />
    );
  });

  return (
    <div>
      { otherOptionsItems }
    </div>
  );
};

OtherOptionsList.propTypes = {
  calendarStartDateStr: PropTypes.any,
  calendarEndDateStr: PropTypes.any,
  otherOptions: PropTypes.object.isRequired,
  otherOptionSaveBody: PropTypes.object,
  updateOtherOption: PropTypes.func,
  showNotification: PropTypes.func,
  fetchActivities: PropTypes.func,
  readOnly: PropTypes.bool.isRequired,
  onOptionToggled: PropTypes.func
};

OtherOptionsList.defaultProps = {
  calendarStartDateStr: null,
  calendarEndDateStr: null,
  otherOptionSaveBody: {},
  updateOtherOption: () => {},
  showNotification: () => {},
  fetchActivities: () => {},
  onOptionToggled: null
};

export default OtherOptionsList;
